import React from 'react'
import { useSelector } from 'react-redux'

import ContentLayout from '@lyrahealth-inc/ui-core/lib/molecules/layouts/base/ContentLayout'

import { ROLES } from '../common/constants/appConstants'
import { hasRole } from '../common/utils/utils'
import { getAuthRoles } from '../data/auth/authSelectors'
import PaymentsDashboard from '../payments/dashboard/PaymentsDashboard'

const PaymentsRoutes: React.FC = () => {
  const roles = useSelector(getAuthRoles)

  const getContent = () => {
    if (hasRole(roles, ROLES.PRACTICES_ADMIN)) {
      return <h1>PAYMENTS_DASHBOARD, for Practice Admin </h1>
    } else if (hasRole(roles, ROLES.PROVIDERS_ADMIN)) {
      return <h1>PAYMENTS_DASHBOARD, for Provider Admin </h1>
    } else if (hasRole(roles, ROLES.PAYMENTS_ADMIN)) {
      return <PaymentsDashboard />
    } else if (hasRole(roles, ROLES.INDIVIDUAL_PROVIDER)) {
      return <h1>PAYMENTS_DASHBOARD, for Individual Provider </h1>
    } else {
      return <h1>PAYMENTS_DASHBOARD, default</h1>
    }
  }

  return (
    <div>
      <ContentLayout>
        <div style={{ marginTop: '50px' }}>{getContent()}</div>
      </ContentLayout>
    </div>
  )
}

export default PaymentsRoutes
